// removed by extract-text-webpack-plugin
module.exports = {"container":"l2Iy","nameRow":"_2ZWG","image":"toF6","nameAndPosition":"_3wNV","contactRow":"_1X1V","callContainer":"_5DC_","emailContainer":"_36t2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/ContactPerson/styles.scss
// module id = 412
// module chunks = 0